import { db } from '../client/index';
import { collection, getDocs, doc, getDoc, addDoc, updateDoc, deleteDoc, query, where } from 'firebase/firestore/lite';

const usersCollection = collection(db, 'users');

export const getUsers = async () => {
  try {
    const usersSnapshot = (await getDocs(usersCollection)).docs;
    const usersItems = usersSnapshot.map(user => ({
      ...user.data(),
      id: user.ref.id
    }));
    return usersItems;
  } catch (err) {
    return err;
  }
}

export const getUser = async (id) => {
  try {
    const userSnapshot = doc(db, 'users', id);
    const userItem = await getDoc(userSnapshot);
    return userItem.exists() ? {
      ...userItem.data(),
      id: userItem.ref.id
    } : null;
  } catch (err) {
    return err;
  }
}

export const getUserByEmail = async (email) => {
  try {
    const querySnapshot = query(usersCollection, where('email', '==', email));
    const queryItems = await (await getDocs(querySnapshot)).docs;
    const users = queryItems.map(user => ({ id: user.ref.id, ...user.data() }));
    return users[0];
  } catch (err) {
    return err;
  }
}

export const createUser = async (user) => {
  try {
    const { id } = await addDoc(usersCollection, user);
    const userAdded = { ...user, id };
    return userAdded;
  } catch (err) {
    return err;
  }
}

export const updateUser = async (id, user) => {
  try {
    const userRef = doc(db, 'users', id);
    await updateDoc(userRef, user);
    return { id, ...user };
  } catch (err) {
    return err;
  }
}

export const deleteUser = async (id) => {
  try {
    const userRef = doc(db, 'users', id);
    await deleteDoc(userRef);
    return id;
  } catch (err) {
    return err;
  }
}